import Head from 'next/head';

import React from 'react';

import { UploadedImage } from '@customTypes/UploadedImage';

type Props = {
  metaTitle: string;
  metaDescription: string;
  shareImage?: UploadedImage;
  custom?: {
    [otherOpt: string]: string;
  };
};

const HeadMeta: React.FC<Props> = (props) => {
  const { shareImage, metaTitle, metaDescription: content, custom = {} } = props;
  if (shareImage?.data)
    return (
      <Head>
        <meta property={metaTitle} content={shareImage.data.attributes.url}></meta>
      </Head>
    );
  if (custom)
    return (
      <Head>
        <meta {...custom} />
      </Head>
    );
  return (
    <Head>
      <meta name={metaTitle} content={content}></meta>
    </Head>
  );
};

export default HeadMeta;
